import { Autocomplete, TextField } from '@mui/material';
import { Department } from '../../interfaces/Department';

interface DepartmentAutocompleteProps {
  label?: string;
  width?: number;
  backgroundColor?: string;
  disabled?: boolean;
  error?: boolean;
  options: Department[];
  value: Department | null;
  onChange: (newDepartment: Department | null) => void;
}

const DepartmentAutocomplete = (props: DepartmentAutocompleteProps) => (
  <Autocomplete
    renderInput={(params) => (
      <TextField
        {...params}
        label={props.label}
        variant='outlined'
        size='small'
        error={props.error}
        disabled={props.disabled}
      />
    )}
    options={props.options}
    getOptionLabel={(department) => department.name}
    value={props.value}
    onChange={(_, newDepartment) => props.onChange(newDepartment)}
    disabled={props.disabled}
    sx={{
      width: props.width,
      minWidth: 200,
      maxWidth: 300,
      flex: '1 1 0',
      backgroundColor: props.backgroundColor,
    }}
  />
);

export default DepartmentAutocomplete;
